import Vue from 'vue'
import mask from 'components/masking/masking.vue'
import myRadio from 'components/myRadio/myRadio.vue'
import myCheckbox from 'components/myCheckbox/myCheckbox.vue'
import ErrPanel from 'components/errorPanel/errorPanel'
import Preloader from 'components/preloader/Preloader'
import 'framework7/lazy-components/swipeout.css'
import 'framework7/lazy-components/dialog.css'
/* import 'framework7/lazy-components/form'*/
import 'framework7/lazy-components/input'
import Dialog from 'framework7/lazy-components/dialog'
import Swipeout from 'framework7/lazy-components/swipeout'
import { f7Navbar, f7Block, f7Page, f7Preloader } from 'framework7-vue'
import baseToolbar from 'components/baseToolbar/BaseToolbar'

// 自定义组件
Vue.component('masking', mask)
Vue.component('myRadio', myRadio)
Vue.component('myCheckbox', myCheckbox)
Vue.component('errPanel', ErrPanel)
Vue.component('preloader', Preloader)
Vue.component('baseToolbar', baseToolbar)

Vue.component('f7Navbar', f7Navbar)
Vue.component('f7Block', f7Block)
Vue.component('f7Page', f7Page)
Vue.component('f7Preloader', f7Preloader)
window.Framework7.use([Swipeout, Dialog])
/*

function loadF7Modules (modulesName) {
  const modulesToLoadJs = modulesName.map((moduleName) => import(`framework7/components/${moduleName}/${moduleName}.js`))
  modulesName.map((moduleName) => import(`framework7/lazy-components/${moduleName}.css`))
  return Promise.all(modulesToLoadJs).then((modules) => {
    app.$f7.loadModules(modules.map((module) => module.default))
  })
}

loadF7Modules(['dialog'])*/
